import React, { useEffect, useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { GetUserToken, ShowLoading, ShowNetworkErrorMessage } from "../../utilities/functions";
import { NavigationBar } from "../../components/NavigationBar/NavigationBar";
import { GetCurrentUserApi } from "../../api/userApiCalls";
import { IUser } from "../../utilities/interfaces";
import Footer from "../../components/Footer/Footer";
import img from "../../images/accessDenied.png";
import { endSession } from "../../middleware/session";

const ErrorPermissionPage = () => {
  const { logout } = useAuth0();
  const token = GetUserToken();
  const [networkError, setNetworkError] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);

  const [, setUserLoggedIn] = useState<IUser>();

  //---------------------------------------------------------------------------------------------------------------------------------------------------

  function LogOutUser() {
    endSession(logout);
  }

  async function GetCurrentUser() {
    await GetCurrentUserApi(token).then((response) => {
      const currentUser: IUser = response[0];
      const errors = response[1];

      if (errors) {
        setNetworkError(true);
      }

      if (currentUser) {
        setUserLoggedIn(currentUser);
      }
    });
  }

  //---------------------------------------------------------------------------------------------------------------------------------------------------

  useEffect(() => {
    if (loading) {
      GetCurrentUser().then(() => setLoading(false));
    }
  }, []);

  //---------------------------------------------------------------------------------------------------------------------------------------------------

  return (
    <React.Fragment>
      {!loading && networkError && <div>{ShowNetworkErrorMessage()}</div>}
      {loading && !networkError && <div>{ShowLoading()}</div>}
      <div id="header">
        <NavigationBar />
      </div>
      {!loading && !networkError && (
        <div className="container my-4">
          <div className="mt-5 d-flex flex-row bd-highlight  justify-content-center ">
            <div className="bd-highlight  width-max-500">
              <div className="row mb-3 mt-3">
                <div className=" mx-5">
                  <img alt="Error image" src={img} width="100" />
                </div>
                <h2 className=" mx-5 mt-4">
                  <span className="text-center  text-blue">Access Denied! </span>
                </h2>
              </div>
              <div className="mx-5 ">
                <div className="">
                  <p className="text-justify">You need permission to access this page. Please, talk to the System Administrator of your organisation. </p>
                </div>
              </div>
              <div className="d-grid gap-3 d-md-flex  mt-4 mb-3 me-1">
                <div className="d-grid gap-3 d-md-flex mx-5 mt-4 mb-3 me-1">
                  <a href="" type="button" onClick={() => LogOutUser()}>
                    Log out
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      <div id="footer">
        <Footer />
      </div>
    </React.Fragment>
  );
};
export default ErrorPermissionPage;
